var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2501 16.25C10.1494 16.2466 10.0504 16.2227 9.95927 16.1797C9.86814 16.1367 9.78674 16.0755 9.72007 16C9.57962 15.8593 9.50073 15.6687 9.50073 15.47C9.50073 15.2712 9.57962 15.0806 9.72007 14.94L12.7201 11.94L9.72007 8.93996C9.66075 8.79595 9.64773 8.63704 9.68283 8.4853C9.71792 8.33355 9.79939 8.1965 9.91592 8.09316C10.0325 7.98982 10.1783 7.92532 10.3331 7.90862C10.488 7.89192 10.6442 7.92385 10.7801 7.99996L14.2801 11.5C14.4205 11.6406 14.4994 11.8312 14.4994 12.03C14.4994 12.2287 14.4205 12.4193 14.2801 12.56L10.7801 16C10.7134 16.0755 10.632 16.1367 10.5409 16.1797C10.4497 16.2227 10.3508 16.2466 10.2501 16.25Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.5f84d66a2bc222ffa4b72218b6e01b2a.svg";
export { ForwardRef as ReactComponent };